import "./multiPackages.css"
import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';




function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}





const MultiPackages = (props) => {

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="container d-flex justify-content-center container-packages">
      <Box className=" col-12">
        <Box sx={{width: '100%'}}>
          {/* <Box sx={{  bgcolor: 'background.paper', border: '1px solid #000' }}> */}
          <div className="d-flex justify-content-center ">
            <Tabs
              value={value}
              onChange={handleChange}
              allowScrollButtonsMobile
              centered
              variant="scrollable"
              scrollButtons="auto"
              
              aria-label="scrollable auto tabs example"
            >
              {/* <Tab label="PAQUETES TODO INCLUIDO" {...a11yProps(0)}  />
              <Tab label="PAQUETES DE LLAMADAS Y SMS" {...a11yProps(1)}  />
              <Tab label="PAQUETES SOLO INTERNET"  {...a11yProps(2)} />
              <Tab label="RECARGA DESDE EL APP RECIBES 1GB GRATIS" /> */}
              {props.data.items.map((item, i)=> {
                return(<Tab label={item.title} {...a11yProps(i)}  />)
              })}
              
            </Tabs>
          </div>
          {/* </Box> */}
          <div>
            {props.data.items.map((item, index) => {
              return (
              <TabPanel value={value} index={index}>
                 <p className="p-4">
                      {item.description}
                </p>
                <div className="row d-flex justify-content-center ">
                  
                      {item.items.map((itempa, i) => {
                        return (
                          <div key={i} className=" col-multi-package  ">
                            <div className="">
                            <div>
                              {/* <div className="col-12 package-label">PAQUETE</div> */}
                              <div className="col-12 package-label">{itempa.type}</div> 
                              <div className="col-12 pt-2 title-multi-package">{itempa.title}</div>
                              <div className="col-12 pt-4 price-label">{itempa.price}</div>
                              <div className="col-12 pt-3 task-label">Incluye impuestos</div>
                              <div className="col-12 p-2 description-packge"> <p dangerouslySetInnerHTML={{__html: itempa.description}}></p></div>
                              {/* <hr /> */}
                              { itempa.included && itempa.included !== "" && <div className="col-12  task-label">Incluye</div>}
                              <div className="col-12 p-1 description-packge  "> <p dangerouslySetInnerHTML={{__html: itempa.included}}></p></div>
                              <br />
                              <br />
                              <div className="col-12  pb-3 btn-bottom d-flex justify-content-center">
                                <a href={itempa.cta_btn} target="_blank" rel="noreferrer">
                                  <button className="button-package" > { itempa.label_btn}</button>
                                </a>
                              </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                </div> 
                
              </TabPanel>)
            })}
          </div>
          {/* <TabPanel value={value} index={0}>
            <div className="row col-12  d-flex align-items-center justify-content-center">
            <p className="p-4">
              Compra  con tu billetera Tigo Money tu paquete favorito, mira aquí para ver paso a paso como
              hacerlo.
            </p>
              {props.data.items[0].items.map((item, index) => {
                return (
                  <div key={index} className="col-md-3 col-package d-flex justify-content-center">
                    <div className="">
                      <div className="col-12 package-label">PAQUETE</div>
                      <div className="col-12 pt-2 title-package">{item.title}</div>
                      <div className="col-12 pt-2 price-label">{item.price}</div>
                      <div className="col-12 pt-3 task-label">Incluye impuestos</div>
                      <div className="col-12 p-3 description-packge"> <p dangerouslySetInnerHTML={{__html: item.description}}></p></div>
                      <div className="col-12  pb-4 btn-bottom d-flex justify-content-center">
                        <a href={item.cta_btn} target="_blank" rel="noreferrer">
                          <button className="button-package" > { item.label_btn}</button>
                        </a>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div> 
          </TabPanel>
          <TabPanel value={value} index={1}>
          <div className="row col-12  d-flex align-items-center justify-content-center">
           <p className="p-4">
            Recarga con tu billetera Tigo Money tu número Tigo o el de otro número Tigo, mira aquí para ver
            paso a paso como hacerlo 
           </p>
              {props.data.items[1].items.map((item, index) => {
                return (
                  <div key={index} className="col-md-3 col-package d-flex justify-content-center">
                    <div className="">
                      <div className="col-12 package-label">PAQUETE</div>
                      <div className="col-12 pt-2 title-package">{item.title}</div>
                      <div className="col-12 pt-2 price-label">{item.price}</div>
                      <div className="col-12 pt-3 task-label">Incluye impuestos</div>
                      <div className="col-12 p-3 description-packge" dangerouslySetInnerHTML={{__html: item.description}}></div>
                      <div className="col-12  pb-4 btn-bottom d-flex justify-content-center">
                        <a href={item.cta_btn} target="_blank" rel="noreferrer">
                          <button className="button-package" > { item.label_btn}</button>
                        </a>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div> 
          </TabPanel>
          <TabPanel value={value} index={2}>
            Item Three
          </TabPanel> */}
        </Box>
      </Box>


      {/* <div
        className="row col-10 d-flex align-items-center justify-content-center"
      >
        {props.data.items.map((item, index) => {
          return (
            <div key={index} className="col-md-3 col-package d-flex justify-content-center">
              <div className="">
                <div className="col-12 package-label">PAQUETE</div>
                <div className="col-12 pt-2 title-package">{item.title}</div>
                <div className="col-12 pt-2 price-label">{item.price}</div>
                <div className="col-12 pt-3 task-label">Incluye impuestos</div>
                <div className="col-12 p-3 description-packge" dangerouslySetInnerHTML={{__html: item.description}}></div>
                <div className="col-12  pb-4 btn-bottom d-flex justify-content-center">
                  <a href={item.cta_btn} target="_blank" rel="noreferrer">
                    <button className="button-package" > { item.label_btn}</button>
                  </a>
                </div>
              </div>
            </div>
          );
        })}
      </div> */}
    </div>
  );
};
export default MultiPackages;
